import Vue from 'vue';
import Api from '../../api/api'
import { parseISO, format } from 'date-fns';

const HOUR_FORMAT = "HH:mm";

const defaultYouTubeUrl = (track) => {
  const video = track.videos?.find(video => video.tags === 'default')
  return video ? `https://youtu.be/${video.id}` : null
}

export default {
  namespaced: true,
  state: {
    perPage: 300,
    isLoading: false,
    channel: false,
    nextUrl: '',
    tracks: [],
  },
  actions: {
    // This function is a bit of a mess but I have no idea how to make it better. Suggestions welcome
    async fetchSlugOrDefault({ commit, dispatch, rootGetters, rootState }, slug) {
      await dispatch('channels/fetch', {}, { root: true })

      let channelId;
      if (slug) {
        channelId = (
          rootGetters['channels/channelBySlug'](slug) ||
          rootGetters['channels/channelById'](slug) // Given slug can be a station-id as well
        )?.id
      }
      if (!channelId) {
        channelId = rootState.stations.stationId
      }

      commit('SET_CHANNEL', channelId)
      dispatch('fetch', new Date())
    },
    async fetch({ state, commit, rootState }, date ) {
      if (state.isLoading) { return; }

      let url = state.nextUrl

      if (date) {
        const station_id = state.channel || rootState.stations.stationId;
        const from = date.toISOString()
        url = `/2.0/tracks/plays?limit=${state.perPage}&upto=${from}&_station_id=${station_id}`
      }

      commit('LOAD_START');
      try {
        const response = await Api.get(url);
        const { data: { played_tracks: tracks, pagination: pagination } } = response;
        const newTracks = tracks
          .map(track => ({
            id: track.id,
            thumbnail: track.thumbnail,
            artist: track.artist.name,
            title: track.title,
            selectorCode: track.selector_code,
            playedAt: parseISO(track.played_at),
            start: format(parseISO(track.played_at), HOUR_FORMAT),
            slug: track.slug,
            hooks: {
              spotify: track.spotify_url,
              itunes: track.affiliate_url,
              youtube: defaultYouTubeUrl(track),
              m4a: track.hooks?.m4a,
            },
          }));
        commit('TRACKS_FETCHED', { tracks: newTracks, nextUrl: pagination.previous });
      } catch (error) {
        console.error(error); // eslint-disable-line
        commit('LOAD_FAIL');
      }
    },
    fetchNext({ dispatch }) {
      dispatch('fetch');
    },
    setChannel({ commit, dispatch }, channel) {
      commit('SET_CHANNEL', channel);
      dispatch('fetch', new Date());
    },
    setDate({ commit, dispatch }, date) {
      commit('SET_TRACKS', []);
      dispatch('fetch', date);
    },
    setPerPage({ commit }, limit) {
      commit('SET_PER_PAGE', limit)
    }

  },
  mutations: {
    TRACKS_FETCHED(state, { tracks, nextUrl }) {
      state.tracks = state.tracks.concat(tracks);
      state.nextUrl = nextUrl;
      state.isLoading = false;
    },
    LOAD_START(state) {
      state.isLoading = true;
    },
    LOAD_FAIL(state) {
      state.isLoading = false;
    },
    SET_TRACKS(state, tracks) {
      state.tracks = tracks;
    },
    SET_CHANNEL(state, channel) {
      Vue.set(state, 'channel', channel);
      state.tracks = [];
    },
    SET_PER_PAGE(state, limit) {
      state.perPage = limit;
    }
  }
}
